import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tobps'
})
export class TobpsPipe implements PipeTransform {

  transform(value: string, ...args: any[]): any {
    // tslint:disable-next-line:no-eval
    return eval(value
      .replace('B', '')
      .replace('K', '*1024')
      .replace('M', '*1024*1024')
      .replace('G', '*1024*1024*1024')
      .replace('T', '*1024*1024*1024*1024'));
  }

}
